import React from 'react';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useIntl } from 'react-intl';

const styles = {
  root: {
    width: '100%',
    height: 'auto',
    marginBottom: '20px',
  },
};

const CustomTextField = (props) => {
  const intl = useIntl();
  const { title, classes, children, className, value, ariaLabel, ...other } = props;
  const shrink = typeof value === 'number' || typeof value === 'boolean' ? true : !!value;

  return (
    <TextField
      InputLabelProps={{ shrink }}
      className={clsx(classes.root, className)}
      label={title ? intl.formatMessage({ id: title }) : ''}
      value={value}
      InputProps={{
        'aria-label': ariaLabel,
        classes: { input: classes.input },
      }}
      {...other}>
      {children}
    </TextField>
  );
};

CustomTextField.propTypes = {
  title: PropTypes.any,
  classes: PropTypes.any,
  children: PropTypes.node,
  ariaLabel: PropTypes.any,
  value: PropTypes.any,
};

export default withStyles(styles)(CustomTextField);
